
import React from 'react';
import { cn } from '@/lib/utils';

interface ChartLegendProps {
  payload: any[];
  hiddenLines?: string[];
  onLegendClick?: (dataKey: string) => void;
}

const ChartLegend: React.FC<ChartLegendProps> = ({ 
  payload, 
  hiddenLines = [], 
  onLegendClick 
}) => {
  const isInteractive = !!onLegendClick;
  
  return (
    <ul className="flex flex-wrap justify-center gap-3 mt-4">
      {payload.map((entry: any, index: number) => (
        <li 
          key={`item-${index}`}
          className={cn(
            "flex items-center gap-2 px-3 py-1.5 rounded-md",
            isInteractive 
              ? "cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" 
              : "bg-gray-50 dark:bg-gray-800",
            hiddenLines.includes(entry.dataKey) && "opacity-60 bg-gray-100 dark:bg-gray-700"
          )}
          onClick={isInteractive ? () => onLegendClick(entry.dataKey) : undefined}
        >
          <span 
            className="inline-block w-3 h-3 rounded-full" 
            style={{ backgroundColor: entry.color }}
          />
          <span className="text-sm font-medium">{entry.value}</span>
        </li>
      ))}
    </ul>
  );
};

export default ChartLegend;
